/**
 * This is the twofa routes configuration.
 * Only configure routes in this file.
 * @memberOf twofa Module
 * @namespace twofa Routes
 */

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf twofa Module.twofa Routes
 * @ngInject
 */
var config = function ($stateProvider) {
	/* Create the twofa state and assign the template and controller. */
	$stateProvider
		.state('login.2fa', {
			url: '/2fa',
			template: '<ui-view>',
			controller: 'twofaController',
			controllerAs: 'twofaController',
		});
}

export default config;


// WEBPACK FOOTER //
// ./src/login/2fa/2fa.route.js